<div [ngClass]="'ft-theme_' + theme">
    <div *ngIf="startDate && !fixedRangeDays" class="ft-monthly-daterange-back" (click)="reset()"><mat-icon class="icon-sm" svgIcon="arrow-left" /> Change start date</div>
    <div class="ft-monthly-daterange-header mb-5 text-center v-center">
        <ng-container *ngIf="fixedRangeDays">
            <div class="ft-monthly-daterange-header_title h5">
                Select a start date<ng-container *ngIf="texts?.showFixedRangeDaysInStartPrompt"> for your {{ fixedRangeDays }}-day range</ng-container>
            </div>
        </ng-container>
        <ng-container *ngIf="!fixedRangeDays">
            <ng-container *ngIf="!startDate">
                <div class="ft-monthly-daterange-header_title h5">Select a start date or month</div>
            </ng-container>
            <ng-container *ngIf="startDate">
                <ng-container *ngIf="availableDayRanges?.length">
                    <div *ngIf="selectMode === selectModeEnum.Range" class="ft-monthly-daterange-header_title">Select a date range</div>
                    <div *ngIf="selectMode === selectModeEnum.Day" class="ft-monthly-daterange-header_title">Select an end date</div>
                    <div *ngIf="selectMode === selectModeEnum.Range" @expandCollapse>
                        <div class="mt-4"></div>
                        <div class="ft-monthly-daterange-ranges" [class.-hovered]="!!hoveredDate">
                            <ng-container *ngFor="let range of availableDayRanges">
                                <button *ngIf="startDate | rangeDate : range as rangeDate"
                                        (mouseenter)="hoveredDate = rangeDate; changeDetection();"
                                        (mouseleave)="hoveredDate = null"
                                        [disabled]="isRangeDisabled(rangeDate)"
                                        (click)="onDateSelection(hoveredDate)"
                                        class="ft-monthly-daterange-range -outline"
                                        [ngClass]="'ft2-btn-' + (theme === 'dark' ? 'light' : 'default')"
                                        [class.-hovered]="hoveredDate | isDateSame: rangeDate">
                                    {{ range }} {{ range === 1 ? 'day' : 'days' }}
                                </button>
                            </ng-container>
                        </div>
                    </div>
                    <p *ngIf="selectMode === selectModeEnum.Day" class="ft-monthly-daterange-header_sub mt-3">Or a <span class="link" (click)="toggleMode()">date range</span></p>
                    <p *ngIf="selectMode === selectModeEnum.Range" class="ft-monthly-daterange-header_sub mt-3">Or a <span class="link" (click)="toggleMode()">specific end date</span></p>
                </ng-container>
                <ng-container *ngIf="!availableDayRanges?.length">
                    <div class="ft-monthly-daterange-header_title h5">Select a end date</div>
                </ng-container>
                <ng-container *ngIf="selectMode == selectModeEnum.Month">
                    <ng-container *ngIf="selectedMonths.length">
                        <div  class="ft-monthly-daterange-header_title h5">
                            {{ selectedMonths[0] | date: 'MMM yyyy' }}
                            <ng-container *ngIf="selectedMonths.length > 1">
                                - {{ selectedMonths[selectedMonths.length - 1] | date: 'MMM yyyy' }}
                            </ng-container>
                        </div>
                        <div  class="solid-text medium-text muted-text mt-1">
                            {{ selectedMonthsDaysTotalCount }} days
                        </div>
                        <button (click)="setSelectedMonthsRange()" class="ft-monthly-daterange-header_apply ft2-btn-primary -large mt-4">
                            {{ texts?.applySelectedMonthsText || 'Apply' }}
                        </button>
                        <p class="ft-monthly-daterange-header_sub mt-6" *ngIf="isStartDateNextMonthAvailable()">Or select an end month</p>
                    </ng-container>

                </ng-container>
            </ng-container>
        </ng-container>
    </div>
    <div class="ft-monthly-daterange-slider">
        <div class="ft-daterange-picker-calendar ft-monthly-daterange" [ngClass]="'-' + theme">
            <ngb-datepicker #dp
                            *ngIf="initialCalendarDate && timestamp"
                            (dateSelect)="onDateSelection($event)"
                            [weekdays]="weekdaysWidth"
                            [displayMonths]="displayMonths"
                            [markDisabled]="markDisabled"
                            [dayTemplate]="t"
                            [startDate]="initialCalendarDate"
                            [maxDate]="maxDate ? (maxDate | dateToNgbDate) : null"
                            [minDate]="minDate ? (minDate | dateToNgbDate) : null"
                            firstDayOfWeek="7"
                            navigation="none"
                            outsideDays="hidden">
                <ng-template ngbDatepickerContent>
                    <swiper-container #swiper ftSwiper [config]="swiperConfig" init="false"
                                      (swiperslidechangetransitionend)="onSlideChange($event)"
                                      (touchstart)="onTouchStart()"
                                      (touchend)="onTouchEnd()">
                        <swiper-slide *ngFor="let month of dp.state.months; let i = index">
                            <div (click)="onSlideClick($event)" class="ft-monthly-daterange-month" #calendarMonth [attr.data-month]="month | json" [class.-no-anim]="!monthAnimation">
                                <div class="ft-monthly-daterange-month_content">
                                    <div  class="ft-monthly-daterange-month_header ft-text-center">
                                        <span *ngIf="!(selectMode == selectModeEnum.Month)"
                                              (mouseenter)="!startDate && !fixedRangeDays && onMonthHover(month)"
                                              (mouseleave)="!startDate && !fixedRangeDays && (hoveredMonth = null)"
                                              [class.-disabled]="!!startDate || !!fixedRangeDays || !isMonthAvailable(month)"
                                              [class.-hovered]="!fixedRangeDays && !(startDate) && isMonthInRange(month)"
                                              (click)="!startDate && !fixedRangeDays && (setMode(selectModeEnum.Month) && toggleMonthSelection(month))">
                                             {{ toDateFormat(month) | date: 'MMMM' }}
                                            <ng-container *ngIf="currentYear !== month.year">
                                                {{ month.year }}
                                            </ng-container>
                                        </span>
                                        <span *ngIf="(selectMode == selectModeEnum.Month)"
                                              (mouseenter)="(hoveredDate = toDateFormat(month)) && changeDetection()"
                                              (mouseleave)="hoveredDate = null"
                                              [class.-disabled]="!isMonthAvailable(month)"
                                              [class.-hovered]="isMonthInRange(month)"
                                              [class.-selected]="isMonthSelected(month)"
                                              (click)="toggleMonthSelection(month)">
                                             {{ toDateFormat(month) | date: 'MMMM' }}
                                            <ng-container *ngIf="currentYear !== month.year">
                                                {{ month.year }}
                                            </ng-container>
                                        </span>
                                    </div>
                                    <ngb-datepicker-month class="ft-mt-2"
                                                          [month]="month" />
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper-container>
                    <div class="swiper-hover-zone -left"></div>
                    <button class="swiper-button-prev"
                            [disabled]="isPrevButtonDisabled"
                            (click)="slidePrev()">
                    </button>
                    <div class="swiper-hover-zone -right"></div>
                    <button class="swiper-button-next"
                            [disabled]="isNextButtonDisabled"
                            (click)="slideNext()">
                    </button>
    <!--                <div class="swiper-scrollbar"></div>-->
    <!--                <div class="swiper-scrollbar-drag"></div>-->
                </ng-template>
            </ngb-datepicker>
            <ng-template #t let-date let-focused="focused" let-disabled="disabled">
                <ng-container *ngIf="isDateInView(date)">
                    <ft-monthly-daterange-day (reset)="reset($event); datepickerFocus();"
                                              (mouseenter)="onDayHover(date)"
                                              (mouseleave)="hoveredDate = null"
                                              [availableDayRanges]="selectMode === selectModeEnum.Range ? availableDayRanges : null"
                                              [dateType]="selectableDateType"
                                              [hoveredDate]="hoveredDate"
                                              [hoveredMonth]="hoveredMonth"
                                              [startDate]="startDate"
                                              [endDate]="endDate"
                                              [selectMode]="selectMode"
                                              [selectedMonths]="selectedMonths"
                                              [focused]="focused"
                                              [disabled]="disabled"
                                              [inactive]="disabled && isInactiveDate(date)"
                                              [dateRef]="date" />
                </ng-container>
            </ng-template>
        </div>
    </div>
</div>
